import React, { useEffect, useState } from "react";
import { getUserProfileActivity } from "../../../apis/dashboard";
import "./AllUser.css";

const UserProfileActivity = ({ userId, onClose }) => {
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userId) {
      fetchActivity();
    }
  }, [userId]);

  const fetchActivity = async () => {
    try {
      setLoading(true);
      const response = await getUserProfileActivity(userId);
      console.log("UserProfileActivity response:", response);
      setActivity(response);
      setError(null);
    } catch (err) {
      console.error("Error fetching user profile activity:", err);
      setError("Failed to load activity data");
    } finally {
      setLoading(false);
    }
  };

  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "N/A";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) return `${hours}h ${minutes}m ${secs}s`;
    if (minutes > 0) return `${minutes}m ${secs}s`;
    return `${secs}s`;
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "N/A";
    
    let date;
    if (typeof timestamp === 'number') {
      if (timestamp > 1000000000000) {
        date = new Date(timestamp);
      } else {
        date = new Date(timestamp * 1000);
      }
    } else if (typeof timestamp === 'string') {
      const num = parseInt(timestamp);
      if (!isNaN(num)) {
        date = num > 1000000000000 ? new Date(num) : new Date(num * 1000);
      } else {
        date = new Date(timestamp);
      }
    } else {
      return "N/A";
    }
    
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleString();
  };

  const formatField = (value) => {
    if (!value) return "N/A";
    if (Array.isArray(value)) return value.join(", ");
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.join(", ");
      } catch {}
    }
    return value;
  };

  const modalStyle = {
    display: 'block',
    position: 'fixed',
    zIndex: 1000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    overflow: 'auto'
  };

  const modalContentStyle = {
    backgroundColor: '#fefefe',
    margin: '5% auto',
    padding: '20px',
    border: '1px solid #888',
    width: '80%',
    maxWidth: '700px',
    borderRadius: '10px',
    maxHeight: '80vh',
    overflow: 'auto'
  };

  const closeButtonStyle = {
    float: 'right',
    fontSize: '28px',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: '#aaa'
  };

  return (
    <div style={modalStyle} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={modalContentStyle}>
        <span style={closeButtonStyle} onClick={onClose}>&times;</span>
        
        <h2 style={{ marginBottom: '20px', color: '#333' }}>User Profile Activity</h2>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <div className="loader"></div>
            <p>Loading activity...</p>
          </div>
        ) : error ? (
          <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
            <p>{error}</p>
            <button onClick={fetchActivity} style={buttonStyle}>Retry</button>
          </div>
        ) : !activity ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>No activity data available</p>
            <button onClick={fetchActivity} style={buttonStyle}>Retry</button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px" }}>
            <div style={cardStyle}>
              <span style={labelStyle}>Status</span>
              <span style={{ ...valueStyle, color: activity?.isOnline ? "green" : "gray" }}>
                {activity?.isOnline ? "● Online" : "○ Offline"}
              </span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Last Active</span>
              <span style={valueStyle}>{formatTimestamp(activity?.lastActiveTime)}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Total Sessions</span>
              <span style={valueStyle}>{activity?.totalSessions ?? 0}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Avg Session Duration</span>
              <span style={valueStyle}>{formatDuration(activity?.avgSessionDuration)}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Total Videos Watched</span>
              <span style={valueStyle}>{activity?.totalVideosWatched ?? 0}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Total Watch Time</span>
              <span style={valueStyle}>{formatDuration(activity?.totalWatchTime)}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>Country</span>
              <span style={valueStyle}>{formatField(activity?.country)}</span>
            </div>

            <div style={cardStyle}>
              <span style={labelStyle}>City</span>
              <span style={valueStyle}>{formatField(activity?.city)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const cardStyle = {
  backgroundColor: "#fff",
  padding: "15px",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "5px"
};

const labelStyle = {
  fontSize: "12px",
  color: "#666",
  fontWeight: "500"
};

const valueStyle = {
  fontSize: "16px",
  fontWeight: "600",
  color: "#333"
};

const buttonStyle = {
  padding: "8px 16px",
  backgroundColor: "#d42cc9",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  marginTop: "10px"
};

export default UserProfileActivity;
